import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import SettingSidebar from "../../components/Setttingsidebar";
import { Link } from "react-router-dom";
import axios from "axios";
import "../../App.css";
import { ApiUrl, videoUrl } from '../../Constants/Weburl'
import CustomTable from "../../components/CustomTable";
import CustomButton from "../../components/CustomButton";
import CustomSwitch from "../../components/Customswitch";
import CustomPagination from '../../components/Custompagination'
import CustomContainer from "../../components/Customsettingscontain";
import CustomInput from '../../components/Custominput';
import { useSearchParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import DeleteModal from "../../components/DeleteModal";
import Layout from "../../components/Layout";
import useExpandableRows from "../../components/useExpandableRows";
import useHiddenColumns from "../../components/useHiddenFields";


const STATUS_COLORS = {
    pending: "#f59e0b",
    confirmed_user: "#2563eb",
    approved: "#16a34a",
    rejected: "#dc2626",
};

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-GB") : "-");

const getImageUrl = (ApiUrl, img) => {
    if (!img) return "";
    if (img.startsWith("http")) return img;
    return `${ApiUrl}${img.replace("\\", "/")}`;
};

export default function DeleteRequests() {
    const [requests, setRequests] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchText, setSearchText] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [busyId, setBusyId] = useState(null);

    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);

    const [expandedReasons, setExpandedReasons] = useState({});


    const { toggleExpand, isExpanded } = useExpandableRows();


    const requestHeaders = [
        { label: "Users", key: "Users", className: "ht-col-name" },
        { label: "Status", key: "Status", className: "ht-col-count" },
        { label: "Reason", key: "Reason", className: "ht-col-reason" },
        { label: "Action", key: "Action", className: "ht-col-action" },
    ];
    const hiddenFields = useHiddenColumns(".rr1-table", requestHeaders);

    const authConfig = () => ({
        headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` },
    });

    useEffect(() => {
        fetchRequests();
    }, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [pageSize, searchText, statusFilter]);

    // GET all delete requests
    const fetchRequests = async () => {
        try {
            const res = await axios.get(`${ApiUrl}api/getdelete-requests`, authConfig());
            console.log("delete requests response", res.data);
            if (res.data.success) setRequests((res.data.data || []).filter(Boolean));
        } catch (err) {
            console.log("fetch delete requests error", err);
        }
    };

    // send mail / approve / reject
    const runAction = async (id, path, method, confirmMsg) => {
        if (confirmMsg && !window.confirm(confirmMsg)) return;
        setBusyId(id);
        try {
            const res = await axios({
                method,
                url: `${ApiUrl}api/getdelete-requests/${id}/${path}`,
                data: {},
                ...authConfig(),
            });
            if (!res.data.success) alert(res.data.message || "Failed");
        } catch (err) {
            alert(err.response?.data?.message || "Something went wrong");
        }
        setBusyId(null);
        fetchRequests();
    };

    const handleView = (item) => {
        setSelectedRequest(item);
        setIsViewModalOpen(true);
    };

    // ---------- filter + pagination ----------
    const filteredRequests = requests.filter((item) => {
        if (!item) return false;
        if (statusFilter && item.status !== statusFilter) return false;

        const search = searchText.toLowerCase().trim();
        if (!search) return true;

        return (
            item?.name?.toLowerCase().includes(search) ||
            item?.email?.toLowerCase().includes(search) ||
            item?.phone?.toLowerCase().includes(search)
        );
    });

    const totalPages = Math.max(1, Math.ceil(filteredRequests.length / pageSize));
    const startIndex = (currentPage - 1) * pageSize;
    const pagedRequests = filteredRequests.slice(startIndex, startIndex + pageSize);

    const renderUser = (item) => (
        <div className="profile-pill">
            <div className="avatar-wrapper">
                <img
                    src={getImageUrl(ApiUrl, item?.avatar)}
                    alt=""
                    style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                    }}
                />
            </div>
            <div className="user-info">
                <div className="username">{item?.username}</div>
                {/* <div className="fullname">{item?.name}</div> */}
                <div className="fullname">{item?.email}</div>
                {!item?.userFound && (
                    <div style={{ color: "#dc2626", fontSize: 12 }}>⚠ No user found for this email</div>
                )}
            </div>
        </div>
    );

    const renderStatus = (item) => (
        <div>
            <span
                style={{
                    padding: "4px 10px", borderRadius: 20, fontSize: 12, color: "#fff",
                    background: STATUS_COLORS[item.status], textTransform: "capitalize",
                    whiteSpace: "nowrap",
                }}
            >
                {item.status.replace("_", " ")}
            </span>
            <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
                Requested: {fmtDate(item.createdAt)}
            </div>
            {item.status === "approved" && (
                <div style={{ fontSize: 12, color: "#6b7280" }}>
                    {item.scheduledDeleteAt
                        ? `Delete on: ${fmtDate(item.scheduledDeleteAt)}`
                        : `Deleted on: ${fmtDate(item.updatedAt)}`}
                </div>
            )}
        </div>
    );

    const renderActions = (item) => {
        const busy = busyId === item?.id;
        const status = item?.status;

        const canReject =
            status === "pending" ||
            status === "confirmed_user" ||
            (status === "approved" && item?.scheduledDeleteAt);

        const iconBtn = (bg) => ({
            width: 34, height: 34, borderRadius: "50%", border: "none",
            background: bg, color: "#fff", display: "inline-flex",
            alignItems: "center", justifyContent: "center",
            cursor: "pointer", fontSize: 16, padding: 0,
        });

        const textBtn = (bg) => ({
            height: 34, padding: "0 14px", borderRadius: 8, border: "none",
            background: bg, color: "#fff", fontSize: 13, fontWeight: 600,
            cursor: "pointer", whiteSpace: "nowrap",
        });

        return (
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: 'end', alignItems: "center" }}>

                {/* 👁 View details */}
                <button
                    type="button"
                    title="View details"
                    style={iconBtn("#6b7280")}
                    onClick={() => handleView(item)}
                >
                    <i className="bi bi-eye"></i>
                </button>

                {/* ✉ Send / Resend verification mail (pending ku mattum) */}
                {status === "pending" && (
                    <button
                        type="button"
                        title={item?.mailSent ? "Resend verification mail" : "Send verification mail"}
                        style={{ ...iconBtn("#2563eb"), opacity: busy ? 0.6 : 1 }}
                        disabled={busy}
                        onClick={() =>
                            runAction(
                                item.id, "send-verification", "POST",
                                item?.mailSent
                                    ? "Do you want to resend the verification email?"
                                    : "Do you want to send a verification email to the user?"
                            )
                        }
                    >
                        <i className="bi bi-envelope"></i>
                    </button>
                )}


                {status === "confirmed_user" && (
                    <button
                        type="button"
                        style={{ ...textBtn("#16a34a"), opacity: (!item?.userFound || busy) ? 0.5 : 1 }}
                        disabled={!item?.userFound || busy}
                        title={!item?.userFound ? "No user found for this email" : "Accept request"}
                        onClick={() =>
                            runAction(
                                item.id, "approve", "PATCH",
                                "If you approve, the account will be permanently deleted after 30 days. Are you sure?"
                            )
                        }
                    >
                        Accept
                    </button>
                )}

                {/* ✖ Reject */}
                {canReject && (
                    <button
                        type="button"
                        style={{ ...textBtn("#dc2626"), opacity: busy ? 0.6 : 1 }}
                        disabled={busy}
                        onClick={() => runAction(item.id, "reject", "PATCH", "Do you want to reject this request?")}
                    >
                        Reject
                    </button>
                )}
            </div>
        );
    };

    return (
        <div className="layout">
            <Layout>
                <CustomContainer className="rr-wrapperhashtag" fluid="false">

                    <div className="ht-header-bar">
                        <h3 className="ht-page-title">Delete Requests</h3>

                        <div className="ht-header-right">
                            <div className="rr-left">
                                Show
                                <select
                                    className="rr-select"
                                    value={pageSize}
                                    onChange={(e) => setPageSize(Number(e.target.value))}
                                >
                                    <option>5</option>
                                    <option>10</option>
                                    <option>25</option>
                                    <option>50</option>
                                </select>
                                entries
                            </div>

                            <div className="rr-left">
                                <select
                                    className="rr-select"
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                >
                                    <option value="">All status</option>
                                    <option value="pending">Pending</option>
                                    <option value="confirmed_user">Confirmed user</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>

                            <div className="rr-right">
                                <span>Search:</span>
                                <CustomInput
                                    className="rr-search"
                                    type="text"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    placeholder="Search name / email / phone"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="rr-card">
                        <CustomTable headers={requestHeaders} className="rr1-table hashtag-table">
                            {pagedRequests.length === 0 ? (
                                <tr>
                                    <td colSpan="3" style={{ textAlign: "center", padding: 20 }}>
                                        No delete requests found
                                    </td>
                                </tr>
                            ) : (
                                pagedRequests.map((item) => {
                                    const rowId = item?.id;

                                    return (
                                        <React.Fragment key={rowId}>
                                            {/* MAIN ROW */}
                                            <tr className="rr-actionshastag">
                                                <td className="ht-col-name">
                                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                        {hiddenFields.length > 0 && (
                                                            <button
                                                                type="button"
                                                                className={`row-expand-toggle ${isExpanded(rowId) ? "is-open" : ""}`}
                                                                onClick={() => toggleExpand(rowId)}
                                                                aria-label="Show more details"
                                                            >
                                                                {isExpanded(rowId) ? "−" : "+"}
                                                            </button>
                                                        )}
                                                        {renderUser(item)}
                                                    </div>
                                                </td>

                                                <td className="ht-col-count">{renderStatus(item)}</td>

                                                <td className="ht-col-reason">
                                                    <div
                                                        onClick={() =>
                                                            setExpandedReasons((prev) => ({
                                                                ...prev,
                                                                [item.id]: !prev[item.id],
                                                            }))
                                                        }
                                                        style={{
                                                            maxWidth: 250,
                                                            display: "-webkit-box",
                                                            WebkitLineClamp: expandedReasons[item.id] ? "unset" : 3,
                                                            WebkitBoxOrient: "vertical",
                                                            overflow: "hidden",
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word",
                                                            lineHeight: "20px",
                                                            cursor: "pointer",
                                                            fontSize: '15px',
                                                            fontWeight: 600,
                                                        }}
                                                    title={expandedReasons[item.id] ? "Click to collapse" : "Click to view full reason"}
                                                    >
                                                    {item?.reason || "-"}
                                                </div>
                                            </td>

                                            <td className="ht-col-action rr-actions">{renderActions(item)}</td>
                                        </tr>

                                            {/* EXPANDED ROW */ }
                                    {
                                        isExpanded(rowId) && hiddenFields.length > 0 && (
                                            <tr className="row-expand-details">
                                                <td colSpan={3}>
                                                    <div className="expand-details">
                                                        {hiddenFields.map(({ field, label }) => (
                                                            <div className="expand-item" key={field}>
                                                                <span className="expand-label">{label}</span>

                                                                {field === "ht-name" && (
                                                                    <div className="expand-value">{renderUser(item)}</div>
                                                                )}
                                                                {field === "ht-count" && (
                                                                    <div className="expand-value">{renderStatus(item)}</div>
                                                                )}
                                                                {field === "ht-reason" && (
                                                                    <div className="expand-value">
                                                                        {item?.reason || "-"}
                                                                    </div>
                                                                )}

                                                                {field === "ht-action" && (
                                                                    <div className="expand-value">{renderActions(item)}</div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                        </React.Fragment>
                        );
                                })
                            )}
                    </CustomTable>

                    <div className="rr-footer">
                        <span>
                            Showing {filteredRequests.length === 0 ? 0 : startIndex + 1} to{" "}
                            {Math.min(startIndex + pageSize, filteredRequests.length)} of{" "}
                            {filteredRequests.length} entries
                        </span>

                        <CustomPagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={(page) => setCurrentPage(page)}
                            className="rr-pagination"
                            pageClassName="rr-page"
                            activeClassName="active"
                            ellipsisClassName="rr-page"
                        />
                    </div>
                </div>
            </CustomContainer>

            {/* DETAILS MODAL */}
            <Modal
                show={isViewModalOpen && selectedRequest !== null}
                onHide={() => setIsViewModalOpen(false)}
                centered
                dialogClassName="modal-box"
            >
                {selectedRequest && (
                    <>
                        <Modal.Header style={{ borderBottom: "none", position: "relative" }}>
                            <CustomButton className="close-btn" onClick={() => setIsViewModalOpen(false)}>
                                ✕
                            </CustomButton>
                            <Modal.Title style={{ marginTop: "-5px" }}>Request Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{ lineHeight: 1.9 }}>
                                <div><b>Name:</b> {selectedRequest.name}</div>
                                <div><b>Email:</b> {selectedRequest.email}</div>
                                <div><b>Phone:</b> {selectedRequest.phone || "-"}</div>
                                <div><b>Reason:</b> {selectedRequest.reason || "-"}</div>
                                <div><b>Requested:</b> {fmtDate(selectedRequest.createdAt)}</div>
                                <div><b>Status:</b> {selectedRequest.status.replace("_", " ")}</div>
                                {selectedRequest.status === "approved" && (
                                    <div>
                                        <b>{selectedRequest.scheduledDeleteAt ? "Delete on" : "Deleted on"}:</b>{" "}
                                        {fmtDate(selectedRequest.scheduledDeleteAt || selectedRequest.updatedAt)}
                                    </div>
                                )}
                                {!selectedRequest.userFound && (
                                    <div style={{ color: "#dc2626" }}>⚠ No user found for this email</div>
                                )}
                            </div>
                        </Modal.Body>
                    </>
                )}
            </Modal>
        </Layout>
        </div >
    );
}

